import {Injectable} from '@angular/core';
import {CanActivateChild} from '@angular/router';
import {NavigationService} from '@app/services/on-route-change.service';


@Injectable({
	providedIn: 'root'
})

export class LeaveGuard implements CanActivateChild {

	constructor(
		private navigationService: NavigationService
	) {
	}

	canActivateChild() {
		if (this.navigationService.preventBack) {
			this.navigationService.preventBack = false;
			return false;
		}
		return true;
	}

}
